import LockIcon from '@material-ui/icons/Lock';

const passwordReset = {
    icon: LockIcon,
};

export default passwordReset;